export default {
  topHeader: {
    buttonText: '打开 App',
    shareImg: '/webAssets/images/img/browser_SC.png'
  },
  articles: {
    likes: '赞',
    comments: '评论',
    reply: '回复',
    noData: '已经全部加载完毕'
  },
  brandAuth: {
    htmlTitle: '成为认证用户',
    bannerImg: '/webAssets/images/brand/banner.png',
    textInfo: [
      '加入名厨认证',
      '获得名厨品牌认证，即可展示您的产品，与高端厨师互动，参与名厨直播、名厨试用等多项活动等。',
      '提交认证申请后，将会有名厨官方工作人员与您取得联系。'
    ],
    formText: {
      nameText: { label: '申请人姓名', placeholder: '请输入申请人姓名' },
      unitText: { label: '企业名称', placeholder: '请输入企业名称' },
      telText: { label: '手机号码', placeholder: '请输入手机号码' },
      desText: { label: '品牌简介', placeholder: '请输入品牌简介' },
      submitText: { label: '提交审核', placeholder: '提交成功', dbApply: '不可重复提交' }
    }
  },
  // 2020名厨个人年度报告
  AnnualReportIndex: {
    title: {
      a1: '我的名厨',
      a2: '年度报告'
    },
    cycle: '数据统计周期 2020.01.01 - 2020.12.31',
    agreement: {
      a1: '我已同意',
      a2: '《名厨用户隐私协议》'
    },
    viewReport: '立即开启',
    agreementChecked: '您未同意隐私协议，无法开启年度报告'
  },
  walkTogether: {
    text1: '知道吗？',
    text2: {
      a1: '我和',
      a2: '名厨',
      a3: '已经一起走过了',
      a4: '天'
    },
    text3: {
      a1: '我第一次打开',
      a2: '名厨'
    }
  },
  annualReport: {
    chefType: [
      {
        i: '我是',
        a: '厨师',
        type: '影响型',
        title: '乐于表达 更多展现',
        info: '对厨师行业、餐饮体系具有个人独到的观点，并有足够的权威性或传播力，进而对他人产生影响'
      },
      {
        i: '我是',
        a: '厨师',
        type: '目标累积型',
        title: '持续积累 快速提升',
        info: '专业上受行业内肯定，自我发展有明确的目标，并不断努力中；不仅是厨师，正往经营或决策者的路上行进'
      },
      {
        i: '我是',
        a: '厨师',
        type: '变化探索型',
        title: '更多可能 更多尝试',
        info: '乐于学习和拥抱新事物，学习意愿比较强，敢于尝试。需要更明确的目标和方向以及清晰的规划'
      },
      {
        i: '我是',
        a: '厨师',
        type: '稳健型',
        title: '稳定出品 保持状态',
        info: '常有稳定的工作或职位，有可能因所在的圈子或城市而形成固定的工作及生活习惯'
      },
      {
        i: '我是',
        a: '厨师',
        type: '职业型',
        title: '面临挑战 需要成长',
        info: '受到工作环境的影响较多，对于职业技术或专业知识需要持续提升，需要接触新事物的环境'
      }
    ],
    shareBtn: '分享',
    goIndex: '回看报告',
    keepPic: '保存图片',
    shareXcx: '长按图片直接转发好友'
  },
  review: {
    text1: {
      a1: '特别的2020',
      a2: '终于结束了',
      a3: '让我来回顾一下吧'
    }
  },
  open: {
    text1: {
      a1: '2020 年',
      a2: '我打开名厨',
      a3: '次'
    },
    text2: {
      a1: '是我最沉浸的一天',
      a2: '这是个不寻常的日子对吗？'
    }
  },
  missed: {
    text1: {
      a1: '欢迎回来，',
      a2: '2020年没有您的消息',
      a3: '从此刻开始，再次出发吧'
    },
    text2: {
      a1: '您可以通过这些方式来快速提高自己',
      a2: '您浏览了作品、资讯',
      a3: '您为喜爱的作品点赞、评论和收藏',
      a4: '您收看了直播、申请了试用',
      a5: '您使用了其他高级功能',
      a6: '您发布了作品和创意'
    },
    chefBtn: 'Chef之路 再次出发'
  },
  welcomeJoin: {
    text1: {
      a1: '欢迎您加入',
      a2: '名厨',
      a3: '您的年度成果，将从此刻开始积累'
    },
    text2: {
      a1: '您可以通过这些方式来快速提高自己',
      a2: '您浏览了作品、资讯',
      a3: '您为喜爱的作品点赞、评论和收藏',
      a4: '您收看了直播、申请了试用',
      a5: '您使用了其他高级功能',
      a6: '您发布了作品和创意'
    },
    chefBtn: '开启我的Chef之路'
  },
  oftenImmersed: {
    isTrue: '完全正确，棒极了！',
    isError: '只差一点点~',
    h4: '我常常沉浸在',
    choose: '选一下',
    more: {
      a1: '投入程度超越了',
      a2: '的用户'
    },
    CreationsandInspiration: '作品和灵感',
    LiveStreaming: '直播',
    Articles: '资讯',
    Collections: '专题',
    Videos: '视频',
    one: {
      a1: '您非常专情哦，对',
      a2: '情有独钟'
    },
    beMore: '您可以用更多时间在名厨学习来提升投入程度'
  },
  interestedCuisine: {
    title: '我最感兴趣的菜系'
  },
  myFavoriteWorks: {
    title: '我最喜爱的作品',
    views: {
      a1: '浏览了 ',
      a2: ' 次，互动了 '
    }
  },
  myFavoriteWorksList: {
    title: '我最喜爱的作品合辑',
    saveCollection: '保存作品合辑',
    tip: '已保存至我的收藏',
    myfavoriteof2020: '已生成#2020年度我最喜爱的作品合辑'
  },
  creationTimes: {
    text1: {
      a1: '我创作了',
      a2: '道作品和灵感',
      a3: '完整作品占',
      a4: '碎片灵感占'
    },
    text2: {
      a1: '创作力超强',
      a2: '大于',
      a3: '的用户'
    },
    text3: {
      a1: '您可以通过创作更多优秀作',
      a2: '品和灵感来提升创作力'
    }
  },
  otherFavoriteWorks: {
    title: '最受喜爱的作品',
    views: '被浏览了',
    likes: '次  收到了',
    saves: '个赞',
    saves2: '收到了',
    saves3: '个收藏',
    message: {
      a1: '*喜爱度根据名厨用户对我作品的浏览、收',
      a2: '藏、点赞等数据综合得出'
    }
  },
  otherFavoriteWorksList: {
    title: '最受喜爱的作品合辑',
    saveCollection: '保存作品合辑',
    tip: '已保存至我的收藏',
    otherfavoriteof2020: '已生成#2020年度最受喜爱的作品合辑'
  },
  follow: {
    title: '谁在悄悄关注我',
    choose: '选一下'
  },
  matchChefType: {
    title: '匹配我的厨师类型'
  },
  noCreation: {
    text1: {
      a1: '我创作了',
      a2: '道作品和灵感',
      a3: '创作力超越了',
      a4: '的用户'
    },
    text2: {
      a1: '点滴积累，汇聚成河',
      a2: '2021，要加油了！'
    }
  },
  annualAchievements: {
    title: '我的年度成就',
    text1: {
      a1: '影响力超过',
      a2: '的名厨用户',
      a3: '影响力根据您在名厨App展现的学习热情、个人能力、行业贡献、传道授业及结交同好综合得出'
    },
    text2: {
      a1: '我的作品影响了',
      a2: '获得了',
      a3: '次推荐',
      a4: '次登上作品榜'
    },
    chefUsers: '想知道您是什么类型的厨师吗？',
    text3: '评估我的厨师类型',
    text4: '人已完成评估',
    text5: '返回名厨获取精彩内容',
    text6: '回看报告',
    text7: '我的影响力暂时难以计算，开始尝试创作或学习吧！'
  },
  shareInfo: {
    title: '原来我是这种类型的厨师！点击查看您的年度报告',
    desc: '您属于哪种类型的厨师？点击查看年度报告，一测便知！'
  },
  index2021: {
    'home': {
      title: '2020-2021名厨指数',
      name: '2020-2021名厨指数',
      tip: '2020-2021名厨指数所有榜单以2020年度名厨App用户行为数据为唯一准则，按照不同维度分别进行严谨计算，共同构成所有用户对作品、内容、食材的态度。',
      share_title: '“2020-2021名厨指数”全面开启',
      share_des: '12大榜单发布，内容精彩纷呈'
    },
    'food': { // 作品人气王
      title: '作品人气王',
      name: '作品人气王',
      tip: '榜单展示2020年度前50道人气作品。<br/>榜单统计规则：在作品人气王投票期间内，由用户投票结果得出。',
      share_title: '“2020-2021名厨指数”——人气作品',
      share_des: '盘点年度最受名厨们欢迎的作品'
    },
    'chinese_food': { // 中餐
      title: '最受关注中餐',
      name: '最受关注中餐',
      tip: '榜单展示2020年度前50道最受关注中餐作品。<br/>榜单统计规则：以2020年名厨App内发布的所有中餐作品的浏览量、点赞量、评论量、收藏量等用户行为数据综合计算得出。',
      share_title: '“2020-2021名厨指数”——最受关注中餐',
      share_des: '盘点年度名厨们烹饪艺术的流行风向'
    },
    'live': { // 直播
      title: '最受关注直播',
      name: '最受关注直播',
      tip: '榜单展示2020年度前20场最受关注直播。<br/>榜单统计规则：以2020年名厨App内所有直播节目的观看人次、弹幕量、收藏量、分享量等数据综合计算得出；',
      share_title: '“2020-2021名厨指数”——最受关注直播',
      share_des: '盘点年度最受关注的直播'
    },
    'condiment': { // 调味品
      title: '最受关注调味品',
      name: '最受关注调味品',
      tip: '榜单展示2020年度前20名最受关注调味品。<br/>榜单统计规则：以2020年名厨App内发布的所有作品的主料、辅料、调料中调味品类的烹饪数据为主要依据，结合作品的数量及质量综合计算得出。',
      share_title: '“2020-2021名厨指数”——最受关注调味品',
      share_des: '盘点年度名厨们的挚爱"调味品"'
    },
    'dessert': { // 甜品
      title: '最受关注甜品',
      name: '最受关注甜品',
      tip: '榜单展示2020年度前50道最受关注甜品作品。<br/>榜单统计规则：以2020年名厨App内发布的所有甜品作品的浏览量、点赞量、评论量、收藏量等用户行为数据综合计算得出。',
      share_title: '“2020-2021名厨指数”——最受关注甜品',
      share_des: '盘点年度名厨们烹饪艺术的流行风向'
    },
    'first': { // 首发作品
      title: '最受关注首发作品',
      name: '最受关注首发作品',
      tip: '榜单展示2020年度前10道最受欢迎的首发作品。<br/>榜单统计规则：以2020年名厨App内发布的所有首发作品的浏览量、点赞量、评论量、收藏量等用户行为数据综合计算得出。',
      share_title: '“2020-2021名厨指数”——最受关注首发作品',
      share_des: '盘点年度最受关注的名厨首发作品'
    },
    'ingredient': { // 食材
      title: '最受关注食材',
      name: '最受关注食材',
      tip: '榜单展示2020年度前20名最受关注食材。<br/>榜单统计规则：以2020年名厨App内发布的所有作品的主料、辅料、调料中食材类的烹饪数据为主要依据，结合作品的数量及质量综合计算得出。',
      share_title: '2020-2021名厨指数”——最受关注食材',
      share_des: '盘点年度最受关注食材'
    },
    'chef': { // 厨师人气王
      title: '厨师人气王',
      name: '厨师人气王',
      tip: '榜单展示2020年度前50位人气厨师。<br/>榜单统计规则：在厨师人气王投票期间内，由用户投票结果得出。',
      share_title: '“2020-2021名厨指数”——人气厨师',
      share_des: '盘点年度最受欢迎的人气厨师'
    },
    'brand': { // 品牌
      title: '最受关注品牌',
      name: '最受关注品牌',
      tip: '榜单展示2020年度前10名最受关注品牌。<br/>榜单统计规则：以2020年名厨App内，品牌相关的直播、试用、动态等数据综合计算得出；',
      share_title: '“2020-2021名厨指数”——最受关注品牌',
      share_des: '盘点年度最受关注的品牌'
    },
    'user': { // 名厨达人
      title: '名厨达人',
      name: '名厨达人',
      tip: '榜单展示2020年度前50位名厨达人。<br/>榜单统计规则：以 2020 年用户在名厨App内的个人互动活跃行为等综合计算得出。',
      share_title: '“2020-2021名厨指数”——名厨达人',
      share_des: '盘点名厨年度最活跃的达人'
    },
    'non_chinese_food': { // 非中餐
      title: '最受关注非中餐',
      name: '最受关注非中餐',
      tip: '榜单展示2020年度前50道最受关注非中餐作品。<br/>榜单统计规则：以2020年名厨App内发布的所有非中餐作品的浏览量、点赞量、评论量、收藏量等用户行为数据综合计算得出。',
      share_title: '“2020-2021名厨指数”——最受关注非中餐',
      share_des: '盘点年度名厨们烹饪艺术的流行风向'
    },
    'author': { // 出品人
      title: '年度出品人',
      name: '年度出品人',
      tip: '榜单展示2020年度前50位年度出品人。<br/>榜单统计规则：以2020 年用户在名厨App内发布的优质作品情况等综合计算得出。',
      share_title: '2020-2021名厨指数”——年度出品人',
      share_des: '盘点名厨年度最具影响力的出品人'
    },
    vote: {
      showText: '榜单揭晓',
      openText: '投票开始',
      nowText: '投票截止',
      endText: '票选揭晓'
    },
    classText: '',
    topTitleClass: 'icon_top_cn',
    bottomDes: '榜单的所有解释权归名厨所有',
    gobackBtn: '返回榜单主页',
    saveBtn: '保存榜单作品合辑',
    savedBtn: '已保存到我的收藏',
    saveText: '收藏',
    savedText: '已收藏',
    followText: '关注',
    followingText: '已关注',
    followingAllText: '相互关注',
    timesUsedText: '使用次数',
    voteText: '去投票'
  },
  auth: {
    home: {
      bannerText1: '名厨认证',
      bannerText2: '成为认证用户<br>获得更多权益',
      nameText1: '实名认证',
      nameText2: '提升账户安全<br>更多推荐位展示<br>作品可被官方收录',
      opnText1: '职业认证',
      opnText2: '专属职业标识<br>作品可被首页推荐<br>赛事、活动优先参与',
      bnsText1: '企业认证',
      bnsText2: '更多的品牌曝光<br>发起企业专属活动<br>精准粉丝营销',
      authHelp: '认证常见问题',
      authSuccess: '已认证',
      authWait: '待审核',
      authFail: '认证失败',
      authNo: '未认证'
    },
    aiAuth: {
      title1: '实名认证',
      title2: '人脸识别',
      formText1: '真实姓名',
      placeholder1: '请输入您的真实姓名',
      formText2: '证件类型',
      placeholder2: '请选择证件类型',
      formText3: '证件号码',
      placeholder3: '请输入您的证件号码',
      nextText: '下一步',
      cardText1: '大陆身份证',
      cardText2: '港澳台身份证、驾照、护照',
      cardText3: '海外身份证、驾照、护照',
      cancel: '取消',
      aiText1: '即将进行人脸验证',
      aiText2: '已阅读并同意',
      aiText22: '名厨隐私权政策',
      aiText3: '开始验证',
      againAuth: '重试',
      statusTip1: '验证失败',
      statusTip2: '认证成功',
      statusTip3: '请重新进行人脸识别',
      statusTip4: '名厨已对您的信息进行加密处理',
      statusTip5: '人工审核通道',
      statusTip6: '信息安全保护中，未经您的授权不对外提供',
      statusTip7: '您也可以上传身份证照片进行人工审核，审核需2个工作日',
      statusTip8: '名厨承诺所有材料仅用于名厨平台内认证使用'
    },
    nameAuth: {
      formText4: '证件照片',
      formText44: '示例',
      formText5: '上传示例',
      formText6: '查看示例',
      formTip1: '请上传您的身份证照片，确保信息清晰可见，提交信息与证件一致',
      btnText1: '提交审核',
      statusTip1: '审核需2个工作日，请耐心等待',
      statusTip2: '请按照错误提示信息进行修改后，重新提交审核',
      statusTip3: '太麻烦？你也可以试试',
      statusTip33: '人脸验证',
      statusTip4: '请上传上述任一证件照片，请确保文字清晰可见',
      statusTip5: '请上传您的证件照片，确保信息清晰可见，提交信息与证件一致',
      imgTip1: '身份证正面',
      imgTip2: '身份证背面',
      imgTip3: '港澳台身份证',
      imgTip4: '护照',
      imgTip5: '驾照',
      isKnow: '我知道了'

    },
    opnAuth: {
      title: '职业认证',
      iconText1: '专属标识',
      iconText2: '首页推荐',
      iconText3: '活动优先参与',
      iconText4: '更多福利',
      titleText: '申请条件',
      titleText1: '当前身份',
      titleText2: '实名认证',
      titleText22: '未完成实名认证',
      titleText3: '粉丝数量',
      itleText33: '当前粉丝数量',
      titleText4: '完整作品',
      titleText44: '完整作品数量',
      statusText1: '去认证',
      statusText2: '已满足',
      statusText3: '未满足',
      statusText4: '已完成实名认证',
      statusText5: '已认证',
      statusText6: '立即申请',
      formText1: '单位名称',
      formText2: '职位名称',
      formText3: '上传在职证明',
      formTip1: '请选择任一类型资料上传，请确保姓名、单位、职位信息清晰可见，姓名与实名信息保持一致',
      formTip2: '在职证明',
      formTip3: '工作证',
      formTip4: '名片',
      formTip5: '下载在职证明模板',
      formTip55: '下载“在职证明”，打印盖章后，拍照上传',
      formTip6: '证件上传示例',
      formTip7: '确保姓名、公司、职位信息拍摄清晰',
      formTip8: '须手持名片拍摄，请确保姓名、公司、职位信息拍摄清晰',
      formTip9: '请上传您的证件照片，确保信息清晰可见，提交信息与证件一致',
      identityText1: '厨师',
      identityText2: '供应商',
      identityText3: '经营者',
      identityText4: '美食爱好者',
      userText1: '身份类型',
      userText2: '大陆用户',
      userText3: '港澳台用户',
      userText4: '海外用户',
      userText5: '身份证',
      userText6: '驾照',
      userText7: '护照'
    },
    brandAuth: {
      text0: '企业认证',
      text1: '企业头像',
      text2: '账号名称',
      text3: '口号',
      text4: '账号介绍',
      text5: '企业名称',
      text6: '机构代码',
      text7: '补充资料',
      text8: '工商营业执照',
      text9: '企业认证公函',
      text10: '删除当前帐号',
      text11: '提示',
      text12: '删除账号后将无法恢复',
      text13: '请上传证件照片,确保信息完整清晰，提交信息与账号信息一致',
      text14: '请上传您的证件照片，确保信息清晰可见，提交信息与证件一致',
      text14_1: '请下载“认证公函”打印并加盖公章后，上传“认证公函”，拍照上传',
      text15: '账号信息',
      text16: '认证材料',
      text18: '展开更多',
      text18_1: '收起',
      text19: '请输入',
      text20: '请说明补材料类型（选填）',
      text21: '补充资料',
      text22: '当企业名与账号名关联度较低时，需要提交补充材料证明二者存在关联关系，如“微博蓝V认证”、“品牌授权书”等。',
      text23: '证件照片',
      text24: '请输入内容',
      text25: '下载认证公函',
      text26: '需要下载盖章后上传',
      text27: '上传认证公函'
    }
  },
  bigEvent: {
    winning: {
      fabu: '发布',
      prizehead: '区分名次',
      choicespan: '获奖名单',
      btnchoice: '选择获奖作品',
      prizebtn: '公布获奖名单',
      prizebtns: '获奖名单公布',
      pluswinning: '添加排名',
      toast: '最多设置五等奖',
      onSearch: '搜索作品名称／出品人姓名',
      awards: '选择获奖名单',
      numberone: ['一等奖 ', '二等奖 ', '三等奖 ', '四等奖 ', '五等奖 '],
      Tips: ['提示', '删除奖项将同步删除该奖项下名单，是否删除', '取消', '确认'],
      Tipss: ['提示', '是否保存当前修改？', '不保存', '保存'],
      delete: '删除',
      Calorific: '按热度值排序',
      Release: '按发布时间排序',
      votes: '按票数排序',
      Confirmation: '确定',
      Tip: ['提示', '获奖名单发布后不可修改，确认发布？', '返回修改', '确定'],
      mode: ['作者', '获得', '请以上获奖用户在中奖名单公布的3天内，联系我们领取奖品。联系方式：（请输入联系方式）']
    },
    info: {
      text1: '为您推荐',
      text3: ['人浏览', '人参与'],
      text3_1: '所有用户均可参加',
      text4: '活动介绍',
      text5: '参与作品',
      text6: '关注',
      text7: '活动奖励',
      text8: '参与方式',
      text9: '温馨提示',
      text10: '相关推荐',
      text11: '热门',
      text12: '最新',
      text12_1: '暂无作品～',
      text13: '距离开始还有：',
      text14: '立即参与',
      text14_1: '您当前使用的软件版本较低，升级后才可参与活动',
      text14_2: '立即升级',
      text14_3: '稍后升级',
      text14_4: ['本活动最多可参与', '次'],
      text15: '活动评选中',
      text15_1: '评选结束',
      text16: '活动已结束',
      text17: '预告',
      text18: '进行中',
      text19: '评选中',
      text20: '已结束',
      text22: '您正在参与活动',
      text23: '已参与活动',
      text24: '参与活动',
      text25: '作品评选',
      text26: '结果公布',
      text27: '投票',
      text28: 'Top 10',
      text29: '每人每日最多投10票',
      text29_1: '每人总投票最多x票',
      text30: ['该作品正在参与', '活动，为Ta投票 >>'],
      text30_1: ['该作品正在参与', '活动，查看投票详情>>'],
      text31: ['我是', '正在参与', '活动'],
      text31_1: '分享活动',
      text31_2: '为自己拉票',
      text31_3: '取消',
      text32: '排名',
      text33: '票数',
      text34: '距上名',
      text35: '邀请好友投票',
      text35_1: '快来为我的作品投票吧～',
      text35_2: '去支持',
      text35_3: '查看活动详情',
      text36: '为Ta投票',
      text36_1: '帮我拉票',
      text37: '恭喜获奖用户，查看获奖详情',
      text37_1: '可以左右滑动选择分享拉票的作品',
      text37_2: '暂无活动介绍',
      text38: '获奖作品',
      text39: '获奖名单',
      text40: '活动',
      text41: '活动管理',
      text42: '审核未通过',
      text43: '审核中',
      text44: '已上线',
      text45: '活动管理',
      text46: '查看数据',
      text47: '发布活动',
      text48: '您还未发布活动哦～马上发起活动',
      text49: '活动管理',
      text50: '活动编辑',
      text50_1: ['活动已发布暂不支持更改，如需更改，请联系名厨小7（微信：xiaoqilaile）', '知道了'],
      text50_2: '活动已提交审核暂不支持更改，如需更改，请联系名厨小7（微信：xiaoqilaile）',
      text51: '获奖公布',
      text51_1: '进入评选环节才可公布获奖名单',
      text52: '更多',
      text52_1: '数据中心',
      text53: '作品数',
      text54: '参与人数',
      text55: '浏览数',
      text56: '活动收藏',
      text57: '活动投票',
      text58: '活动转发',
      text59: '删除',
      text59_1: ['确认删除？', '确认', '取消'],
      text59_2: ['已有用户参与活动，暂不可删除', '知道了'],
      text60: '发布活动',
      text61: '选择活动类型',
      text62: ['线上参与', '无需报名，用户可直接参与。可用于作品征集。亦可配置投票评选环节，根据规则选出获奖作品。'],
      text63: '活动案例看这里',
      text64: '更多活动类型敬请期待',
      text65: '编辑封面',
      text66: '点击上传图片',
      text67: '尺寸：250*121，单张小于5M',
      text68: ['基本信息', '活动名称'],
      text69: '活动类型',
      text70: '活动时间',
      text70_1: '选择用户参与活动时间',
      text70_2: '开始时间不能早于当前时间',
      text70_3: '结束时间不能早于开始时间',
      text71: '是否有评选环节',
      text72: '评选时间',
      text73: '评选规则',
      text74: '评选方式',
      text74_1: '用户投票',
      text74_2: '人工评选',
      text75: '投票用户身份',
      text75_1: '名厨注册用户',
      text75_2: '名厨认证用户',
      text75_3: '不限',
      text76: '每人每日投票次数',
      text77: '每人投票总次数',
      text78: '评选结果公布时间',
      text79: '活动标签',
      text80: '参与活动次数',
      text81: '存草稿',
      text81_1: '保存成功',
      text82: '预览',
      text83: '下一步',
      text84: '是否有活动奖品',
      text85: '发布',
      text85_1: ['请简要介绍活动及亮点',
        '请填写本活动的奖项',
        '请填写用户如何参与活动',
        '请填写参与活动的注意事项或特殊要求'],
      text85_2: ['活动发布需经名厨平台审核，我们会在48小时内完成审核并将审核结果通过站内信的方式通知到您，请您留意查看',
        '知道了'],
      text85_3: '您输入的内容超出字数限制～',
      text85_4: ['文本', '图片'],
      text86: ['我已阅读', '《名厨平台发布活动规范》', '，保证活动真实有效'],
      text86_1: ['是否保存当前修改？', '保存', '不保存'],
      text86_2: '请选择图片',
      text86_3: '请填写活动名称',
      text86_4: '选择用户参与活动时间',
      text86_5: '选择评选时间',
      text86_6: '选择评选结果公布时间',
      text87_1: '返回编辑',
      text87_2: '发布',
      text87_3: '页面仅供预览展示，不可点击',
      text88_1: '审核中',
      text88_2: '活动审核中，我们会在48小时内审核完毕',
      text89: '审核未通过，请修改',
      text89_1: '未通过审核，请修改后再次提交 >>',
      text90: '该活动已被主办方删除',
      text90_1: '返回首页',
      text92: '评选时间不能早于活动时间',
      text93: '公布时间不能早于评选时间',
      text94: '',
      text94_1: '编辑获奖作品',
      text95: '',
      text96: '',
      text97: '',
      text98: '',
      text99: '',
      text99_1: '搜索结果',
      text99_2: '您搜索的作品或出品人不存在',
      text99_3: '暂无作品',
      text100: '',
      text101: '',
      text102: '',
      text102_3: '已选作品',
      text103: '',
      text103_1: '人气',
      text104: '',
      text105: '',
      text106: '活动封面图',
      text107: '',
      text108: '示例',
      text109: '活动图片',
      text110: '活动列表图',
      text111: '尺寸：750*480px，最多5张，单张小于5M',
      text112: '点击上移下移按钮，对图片进行排序',
      text113: '首张封面图',
      text114: '下移',
      text115: '上移',
      text115_1: '完成',
      text116: '',
      text117: '',
      text118: '',
      text119: '',
      text120: '没有更多了',
      text121: '活动详情',
      text122: '结束',
      time1: '至',
      time2: ['年', '月', '日', '时', '分'],
      class1: ''
    }
  }
}
